<script>
    export default {
        name: 'expensesTable',

        props: {
            expenses: null,
            whereLive: null,
            isCalc: null
        },

        computed: {
            showCampus: function () {
                if (!this.isCalc) {
                    return true;
                } else {
                    return (this.isCalc && this.whereLive !== 'withfamily')
                }
            },
            showFamily: function () {
                if (!this.isCalc) {
                    return true;
                } else {
                    return (this.isCalc && this.whereLive === 'withfamily')
                }
            }
        }

    }
</script>

<template>
    <div class="a-tableWrapper" >
        <div class="a-tableWrapperSlider">
            <table v-if="expenses.length" class="a-table--responsive a-table tf-table" :class="{filtered:isCalc}">
                <thead>
                <tr>
                    <th>Expense</th>
                    <th :class="{dim:!showCampus}">On Campus/Off Campus</th>
                    <th :class="{dim:!showFamily}">Living With Family</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="expense in expenses" :key="expense.id">
                    <td>{{expense.nameOfCost}}</td>
                    <td :class="{dim:!showCampus}">{{expense.onOffCampusAmount | toCurrency}}</td>
                    <td :class="{dim:!showFamily}">{{expense.withRelativesAmount | toCurrency}}</td>
                </tr>
                </tbody>
            </table>
            <p v-if="isCalc && !expenses.length" class="tf-incompleteStep">Please complete Step 1 to see applicable costs.</p>
        </div>
    </div>
</template>
